import emotion from 'emotion/dist/emotion.umd.min.js';
const { css } = emotion;

export const frameContainer = css`
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;700&display=swap');
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  font-family: "Open Sans", sans-serif;
  & div {
    box-sizing: border-box;
  }
`